import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
// import { MaplibreExportControl, Size, PageOrientation, Format, DPI} from "@watergis/maplibre-gl-export";
// import '@watergis/maplibre-gl-export/css/styles.css';
@Component({
  selector: 'lib-analysis-print-map',
  standalone:true,
  imports:[MatSelectModule,MatOptionModule,FormsModule],
  templateUrl: './analysis-print-map.component.html',
  styleUrls: ['./analysis-print-map.component.css']
})
export class AnalysisPrintMapComponent implements OnInit {
  @Input() mapCarto: any; 
  
  // pageSize = ['A2', 'A3', 'A4', 'A5', 'A6', 'B2', 'B3', 'B4', 'B5', 'B6']
  pageOreintation = ['Portrait', 'Landscape']
  printType = ['PNG', 'JPEG', 'PDF', 'SVG']
  printDPI = [72, 96, 200, 300, 400];
  pageSize = [{type : 'A2', size :  [594, 420]},
  {type : 'A3', size :  [420, 297]},
  {type : 'A4', size :  [297, 210]},
  {type : 'A5', size :  [210, 148]},
  {type : 'A6', size :  [148, 105]},
  {type : 'B2', size :  [707, 500]},
  {type : 'B3', size :  [500, 353]},
  {type : 'B4', size :  [353, 250]},
  {type : 'B5', size :  [250, 176]},
  {type : 'B6', size :  [176, 125]}]
  
  pageSizeControl = 'A2';
  pageOreintationControl = 'Portrait';
  printTypeControl = 'PNG';
  printDPIControl:any = 96;

  fileFormate = [
    { key: 'image', text: 'Image' },
    { key: 'pdf', text: 'PDF' },
  ]
  selectedFormat = 'image';
  @Output() printOfMap = new EventEmitter<any>();
  printMapbox: any;
  @Output() TogglePrintBox = new EventEmitter<any>();
  constructor() { 
  }

  ngOnInit() {
  }


  printMapButton(){
    let page = this.pageSize.find(e => {return e.type == this.pageSizeControl})
    // this.printMapbox = new MaplibreExportControl({
    //   PageSize: page,
    //   PageOrientation: this.pageOreintationControl.toLowerCase(),
    //   Format: this.printTypeControl.toLowerCase(),
    //   DPI: this.printDPIControl
    // })
    
    // this.mapCarto.addControl(this.printMapbox);
    // this.printMapbox.controlContainer.getElementsByClassName('generate-button')[0].click()
    // this.mapCarto.removeControl(this.printMapbox);
  }

  CancelBox(){
    this.TogglePrintBox.emit();
  }

}


